import React from "react";
import { Box, CircularProgress } from "@mui/material";

const LoadingComponent = ({ marginTop, marginBottom }) => {
  return (
    <Box
      sx={{
        //backgroundColor: "background.default",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: marginTop,
        mb: marginBottom,
      }}
    >
      <CircularProgress
        enableTrackSlot
        size="30px"
        aria-label="Loading…"
        sx={{ color: "text.primary" }}
      />
    </Box>
  );
};

export default LoadingComponent;
